import React from 'react'

export default function HelpText({text}) {
  return (
    <div className='text-muted' style={{fontSize:'9px'}}>{text}</div>
  )
}
